import { Spinner } from "@/components/ui/spinner";

type LoadingDisplayProps = {
  status: string;
};

const LoadingDisplay = ({ status }: LoadingDisplayProps): JSX.Element => {
  return (
    <div className="flex min-h-screen items-center justify-center px-4 py-8">
      <div className="w-full max-w-[30rem] rounded-2xl bg-white p-10 shadow-xl">
        <div className="flex flex-col items-center gap-6">
          <Spinner size="xl" />
          <p className="text-center text-lg font-medium text-gray-700">
            {status}
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoadingDisplay;
